/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Creating_JobInputs */

const en_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating Publish Job`)
};

const fr_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation de la tache de publication`)
};

const de_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job veröffentlichen`)
};

const it_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione di un lavoro di pubblicazione`)
};

const ru_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание и публикация задания`)
};

const es_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando un trabajo de publicación`)
};

const zh_cn2_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建发布作业`)
};

const ja_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開ジョブの作成`)
};

const hi_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन कार्य बनाना`)
};

const pt_pt2_iconik_publish_status_creating_job = /** @type {(inputs: Iconik_Publish_Status_Creating_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar vaga de publicação`)
};

/**
* | output |
* | --- |
* | "Creating Publish Job" |
*
* @param {Iconik_Publish_Status_Creating_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_creating_job = /** @type {((inputs?: Iconik_Publish_Status_Creating_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Creating_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_status_creating_job(inputs)
	if (locale === "de") return de_iconik_publish_status_creating_job(inputs)
	if (locale === "it") return it_iconik_publish_status_creating_job(inputs)
	if (locale === "ru") return ru_iconik_publish_status_creating_job(inputs)
	if (locale === "es") return es_iconik_publish_status_creating_job(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_status_creating_job(inputs)
	if (locale === "ja") return ja_iconik_publish_status_creating_job(inputs)
	if (locale === "hi") return hi_iconik_publish_status_creating_job(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_status_creating_job(inputs)
	return en_iconik_publish_status_creating_job(inputs)
});